export default __webpack_public_path__ + "static/media/3796.d457761d.png";